// extracted by mini-css-extract-plugin
export default {"overviewCon":"overviewCon--jzhsA","textAreaCon":"textAreaCon--mMvj_","illustrationCon":"illustrationCon--Ksrax","markerAnimationScale":"markerAnimationScale--st27h"};